import styled from 'styled-components'
import { Button } from '@components/Button'
import { black, grey, textMuted } from '@/theme/colors'
import { radii } from '@/theme/tokens'
import { text } from '@/theme/typography'

/** Grey like the Chat, so its Messages look the same here. */
export const DiscussionSection = styled.section`
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding: 20px 0 16px;
	border-radius: ${radii.card};
	background: ${grey};
`

export const DiscussionHeading = styled.h2`
	${text.title}
	margin: 0;
	padding: 0 16px;
	color: ${black};
`

export const DiscussionDay = styled.div`
	${text.caption}
	color: ${textMuted};
	text-align: center;
	padding: 8px 16px 4px;
`

export const DiscussionPlaceholder = styled.p`
	${text.bodyXs}
	margin: 0;
	padding: 0 16px;
	color: ${textMuted};
`

export const ShowEarlierButton = styled(Button).attrs({ variant: 'ghost', size: 'sm' })`
	align-self: center;
`

export const ChatAboutButton = styled(Button).attrs({ variant: 'secondary' })`
	margin: 4px 16px 0;
`
